import { useCallback, useEffect, useState } from "react";
import "../App.css";
import Calendar from "../components/Calendar";
import Persons from "../components/Persons";
import ActiveBookings from "../components/ActiveBookings";
import { buildApiUrl } from "../config/api";

export var USER_1_KOKORIN = { id: "KOKORIN", label: "Кокорін" };
export var USER_2_KOROVCHENO = { id: "KOROVCHENO", label: "Коровчено" };

export var USERS = [USER_1_KOKORIN, USER_2_KOROVCHENO];

function Home() {
  const [selectedTimes, setSelectedDateTimes] = useState({});
  const [currentUser, serCurrentUser] = useState(USER_1_KOKORIN.id);
  const [bookingRefreshSignal, setBookingRefreshSignal] = useState(0);

  const refreshTime = useCallback(() => {
    fetch(buildApiUrl("/api/bookings/available-slots-all"))
      .then((res) => res.json())
      .then((data) => {
        setSelectedDateTimes(data);
      })
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    refreshTime();
  }, [refreshTime]);

  return (
    <div className="App home">
      <div className="top-service-bar">
        <div>Онлайн запис на тренування</div>
        <div>Швидке бронювання • актуальні слоти</div>
      </div>
      {/* <section className="home-hero">
        <div className="hero-copy">
          <div className="hero-kicker">Онлайн запис</div>
          <h1>Бронюйте тренування швидко та без дзвінків</h1>
          <p className="hero-description">
            Оберіть тренера, відкрийте доступні дати та підтвердьте запис у
            кілька кроків.
          </p>
        </div>
        <div className="hero-stats">
          <div className="hero-stat">
            <strong>2</strong>
            <span>тренери для запису</span>
          </div>
          <div className="hero-stat">
            <strong>24/7</strong>
            <span>доступ до календаря</span>
          </div>
          <div className="hero-stat accent">
            <strong>3 кроки</strong>
            <span>від вибору до заявки</span>
          </div>
        </div>
      </section> */}
      <Persons
        serCurrentUser={serCurrentUser}
        selectedTimes={selectedTimes}
        currentUser={currentUser}
      />
      <ActiveBookings refreshSignal={bookingRefreshSignal} />
      <Calendar
        refreshTime={refreshTime}
        selectedTimes={selectedTimes}
        currentUser={currentUser}
        onBooked={() => setBookingRefreshSignal((s) => s + 1)}
      />
    </div>
  );
}

export default Home;
